<template>
    <SettingsPage title="Administrationsbereich">
        <SmartButton @click="pleaseFail">throws error</SmartButton>
    </SettingsPage>
</template>

<script>
import SettingsPage from "./SettingsPage";
import SmartButton from "@/views/shared/widgets/SmartButton";
export default {
    name: "Admin",
    components: { SmartButton, SettingsPage },
    methods: {
        async pleaseFail() {
            throw "blah";
        }
    }
};
</script>

<style scoped lang="scss"></style>
